type InfoIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const InfoIcon = (props: InfoIconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99967 1.33203C4.31967 1.33203 1.33301 4.3187 1.33301 7.9987C1.33301 11.6787 4.31967 14.6654 7.99967 14.6654C11.6797 14.6654 14.6663 11.6787 14.6663 7.9987C14.6663 4.3187 11.6797 1.33203 7.99967 1.33203ZM7.33301 11.332V7.33203H8.66634V11.332H7.33301ZM7.33301 4.66536V5.9987H8.66634V4.66536H7.33301Z"
      fill="currentColor"
    />
  </svg>
);
